/**
 * A read the App Router discarded from its server-action queue never settles, so
 * an unbounded one waits for good. Far above any real read: this bounds the
 * failure that has no other end, it is not a latency budget.
 */
export const READ_TIMEOUT_MS = 30_000

export const READ_TIMEOUT_MESSAGE = "This took too long to load. Trying again."

/** Rejects where `read` would have waited for good. A polled query clears it on its next tick. */
export function boundedRead<T>(read: Promise<T>): Promise<T> {
  let expire: ReturnType<typeof setTimeout> | undefined
  const deadline = new Promise<never>((_, reject) => {
    expire = setTimeout(() => reject(new Error(READ_TIMEOUT_MESSAGE)), READ_TIMEOUT_MS)
  })
  return Promise.race([read, deadline]).finally(() => clearTimeout(expire))
}
